export const styles = {
    container: {
        color: 'inherit',
        fontWeight: 500
    }
};
